import { laboratoryClient } from '../utils/laboratoryClient';
import { PENDING, SUCCEEDED } from './constants/RequestStatus';
import { EXPERIMENTS } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchExperimentsRequestTypes = createRequestTypes(EXPERIMENTS);
export const FetchExperimentsActions = createRequestActions(FetchExperimentsRequestTypes);
export const fetchExperiments = () => dispatch => {
  dispatch({
    type: FetchExperimentsRequestTypes.REQUEST,
    meta: {
      requestStatuses: {
        [FetchExperimentsRequestTypes.REQUEST]: PENDING
      }
    }
  });
  laboratoryClient.resolve(treatments => {
    return dispatch({
      type: FetchExperimentsRequestTypes.RECEIVE,
      payload: treatments,
      meta: {
        requestStatuses: {
          [FetchExperimentsRequestTypes.REQUEST]: SUCCEEDED
        }
      }
    });
  });
};